import React, { Component } from 'react'
import style from './style.module.less'
import Item from './Item'
import Panel from '@common/Panel'
import api from '@api/home'
import { Spin } from 'hljd'
import auth, { COMMON_FUNCTION } from '../auth'
import path from './path'

@auth(COMMON_FUNCTION)
export default class extends Component {
  state = {
    loading: false,
    list: []
  }

  componentDidMount() {
    this.getCommonFunctionDetail()
  }

  /** 获取常用功能详情 */
  getCommonFunctionDetail = async () => {
    this.setState({
      loading: true
    })
    const { data } = await api.commonFunctionApi()

    this.setState({
      loading: false,
      list: this.formatData(data || [])
    })
  }

  /** 格式化数据，加入跳转路径和icon */
  formatData = data => {
    return data.map(item => {
      return {
        ...item,
        ...(path[item.value] || {})
      }
    })
  }

  render() {
    const { loading, list } = this.state
    return (
      <Panel title="常用功能" contentStyle={{ paddingBottom: 12 }}>
        <Spin spinning={loading}>
          <div className={style.content}>
            {list.map(item => <Item key={item.id || item.value} {...item} />)}
          </div>
        </Spin>
      </Panel>
    )
  }
}
